export default __webpack_public_path__ + "static/media/5C1A8E.a97d45a2.svg";